/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FlattenedOrderStatuses =
  | 'completed'
  | 'delivering'
  | 'failed'
  | 'preparing'
  | 'readyForCourier'
  | 'received';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type LastOrderStatusQueryVariables = Exact<{ [key: string]: never }>;

export type LastOrderStatusQuery = {
  readonly orderStatus:
    | {
        readonly __typename: 'OrderStatus';
        readonly flattenedOrderStatus: Types.FlattenedOrderStatuses;
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly wantedTime: string;
          readonly isPendingFeedback: boolean;
          readonly canTrackOrderStatus: boolean;
          readonly hasEarnedLoyaltyPoints: boolean;
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly asset: { readonly url: string };
            };
          }>;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly entityId: number | null;
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly estimatedDeliveryTime: string | null;
          } | null;
        };
      }
    | Record<PropertyKey, never>
    | null;
};

export const LastOrderStatusDocument = gql`
  query LastOrderStatus {
    orderStatus {
      ... on OrderStatus {
        __typename
        flattenedOrderStatus
        order {
          id
          __typename
          orderType
          wantedTime
          isPendingFeedback
          canTrackOrderStatus
          hasEarnedLoyaltyPoints
          lineItems {
            id
            __typename
            product {
              id
              __typename
              name
              asset {
                url
              }
            }
          }
          restaurant {
            id
            __typename
            entityId
          }
          deliveryOrderDetail {
            id
            __typename
            estimatedDeliveryTime
          }
        }
      }
    }
  }
`;

export function useLastOrderStatusQuery(
  options?: Omit<Urql.UseQueryArgs<LastOrderStatusQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LastOrderStatusQuery, LastOrderStatusQueryVariables>({
    query: LastOrderStatusDocument,
    ...options,
  });
}
